var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { State, Getter } from "vuex-class";
import { UserService } from "~/services/management-service/user.service";
import { Emit, Prop } from "vue-property-decorator";
import clone from "clone";
var ModifyUser = /** @class */ (function (_super) {
    __extends(ModifyUser, _super);
    function ModifyUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modifyModel = {
            userEmail: "",
            userLevel: "",
            userStatus: "",
            caseSwitch: "",
            userName: "",
            realName: "",
            companyCode: "",
            deptId: "",
            password: "888888",
            id: "",
            deptType: ""
        };
        _this.rules = {
            realName: [
                { required: true, message: "请输入姓名", trigger: "blur" },
                {
                    message: "请输入汉字或英文字母",
                    trigger: "blur",
                    pattern: /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/
                }
            ],
            userName: [
                { required: true, message: "请输入用户名", trigger: "blur" },
                {
                    message: "用户名只能包含数字、字母、下划线",
                    trigger: "blur",
                    pattern: /^([A-Za-z0-9_-]+)$/
                },
                { min: 6, message: "请输入6位以上数字、字母、下划线", trigger: "blur" }
            ],
            phone: [
                {
                    message: "请输入正确的电话号码",
                    trigger: "blur",
                    pattern: /^[-0-9()（）]{7,18}$/
                }
            ],
            userEmail: [
                { type: "email", message: "请输入正确的邮箱", trigger: "blur" },
                { min: 1, max: 50, message: "邮箱长度不能超过50位", trigger: "blur" }
            ]
        };
        _this.deptIds = [];
        return _this;
    }
    ModifyUser.prototype.refreshList = function () { };
    ModifyUser.prototype.close = function () { };
    ModifyUser.prototype.reset = function () {
        var modifyForm = this.$refs["modifyUser-form"];
        modifyForm.resetFields();
    };
    ModifyUser.prototype.refresh = function (obj) {
        this.modifyModel = clone(obj);
        this.modifyModel.deptType = obj.deptType;
        this.deptIds = [];
        this.getDeptIds(this.user.deptId);
    };
    /**
     * 机构改变
     */
    ModifyUser.prototype.orgChange = function () {
        if (this.deptIds.length < 1) {
            return;
        }
        var deptId = this.deptIds[this.deptIds.length - 1];
        var deptModel = this.departmentList.find(function (x) { return x.id === deptId; });
        // this.modifyModel.department = deptModel;
        this.modifyModel.deptId = deptModel.id;
        this.modifyModel.deptName = deptModel.deptName;
        this.modifyModel.deptType = deptModel.deptType;
    };
    ModifyUser.prototype.getDeptIds = function (id) {
        var dept = this.departmentList.find(function (x) { return x.id === id; });
        if (dept) {
            this.deptIds.unshift(id);
            this.getDeptIds(dept.parentId);
        }
    };
    /**
     * 新增用户取消
     */
    ModifyUser.prototype.modifyUserCancel = function () {
        //   重置form表单
        var addForm = this.$refs["modifyUser-form"];
        addForm.resetFields();
        this.deptIds = [];
        //   关闭dialog
        this.$emit("close");
    };
    ModifyUser.prototype.commit = function () {
        var _this = this;
        var modifyForm = this.$refs["modifyUser-form"];
        modifyForm.validate(function (valid) {
            if (!valid)
                return false;
            _this.userService.modifyUser(_this.modifyModel).subscribe(function (data) {
                _this.reset();
                _this.$emit("close");
                _this.$message.success("修改成功!");
                _this.deptIds = [];
                //   刷新databox
                _this.$emit("refresh");
            });
        });
    };
    __decorate([
        Dependencies(UserService)
    ], ModifyUser.prototype, "userService", void 0);
    __decorate([
        Prop()
    ], ModifyUser.prototype, "deptId", void 0);
    __decorate([
        Prop()
    ], ModifyUser.prototype, "user", void 0);
    __decorate([
        State
    ], ModifyUser.prototype, "companyList", void 0);
    __decorate([
        State
    ], ModifyUser.prototype, "departmentList", void 0);
    __decorate([
        Getter
    ], ModifyUser.prototype, "departmentData", void 0);
    __decorate([
        Emit("refreshList")
    ], ModifyUser.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], ModifyUser.prototype, "close", null);
    ModifyUser = __decorate([
        Component({
            components: {}
        })
    ], ModifyUser);
    return ModifyUser;
}(Vue));
export default ModifyUser;
